import { Search, X } from 'lucide-react';
import React from 'react';

interface CheckAvailabilityFormProps {
  textValue: string;
  onClearSearch: () => void;
  onSearch: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onCheckAvailability: (fromDate: string, toDate: string, time: string) => void;
  onChangeOption: () => void;
  onDateChange: (dateString: string) => void;
}

const CheckAvailabilityForm: React.FC<CheckAvailabilityFormProps> = ({ onCheckAvailability, onChangeOption, onSearch, onDateChange, textValue, onClearSearch }) => {

  return (
    <>
      <div className="!py-2 !pl-0 mb-5 md:mb-1 !pe-0 flex justify-between dark:border-zink-500">
        <div className="relative xl:col-span-2 !pl-0">
          <input
            type="text"
            className="ltr:pl-8 min-w-60 w-60 ltr:pr-8 rtl:pr-8 rtl:pl-8 search form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
            placeholder="Search for User Display Name or email"
            autoComplete="off"
            onChange={onSearch}
            value={textValue}
          />
          <Search className="inline-block size-4 absolute ltr:left-2.5 rtl:right-2.5 top-2.5 text-slate-500 dark:text-zink-200 fill-slate-100 dark:fill-zink-600" />
          <X
            className="inline-block size-4 absolute ltr:right-2.5 rtl:left-2.5 top-2.5 text-slate-500 dark:text-zink-200 fill-slate-100 dark:fill-zink-600 cursor-pointer hover:text-slate-700 dark:hover:text-zink-100"
            onClick={onClearSearch}
          />
        </div>
      </div>
    </>
  );
};

export default CheckAvailabilityForm;